// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const PeopleRemove2_Stroke1_Corner0_Rounded = createSinglePathSVG({
  path: 'M24 12.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75Zm-5.425 5.517a.75.75 0 0 1-1.15.966c-1.886-2.246-4.48-3.483-7.3-3.483s-5.414 1.237-7.3 3.483a.75.75 0 0 1-1.149-.966c1.4-1.667 3.143-2.85 5.079-3.484a6.375 6.375 0 1 1 6.74 0c1.936.633 3.678 1.817 5.08 3.484Zm-8.45-4.017A4.875 4.875 0 1 0 5.25 9.375a4.88 4.88 0 0 0 4.875 4.875Z',
  viewBox: '0 0 24 24',
  glyph: 'PeopleRemove2_Stroke1_Corner0_Rounded',
})

export const PeopleRemove2_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M24 12.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 .75.75Zm-5.425 5.517a.75.75 0 0 1-1.15.966c-1.886-2.246-4.48-3.483-7.3-3.483s-5.414 1.237-7.3 3.483a.75.75 0 0 1-1.149-.966c1.4-1.667 3.143-2.85 5.079-3.484a6.375 6.375 0 1 1 6.74 0c1.936.633 3.678 1.817 5.08 3.484Zm-8.45-4.017A4.875 4.875 0 1 0 5.25 9.375a4.88 4.88 0 0 0 4.875 4.875Z',
  viewBox: '0 0 24 24',
  glyph: 'PeopleRemove2_Stroke2_Corner0_Rounded',
})
